import React, { useState } from "react";
import "./Payroll.css";
import Header from "../layouts/Employee/Header";
import SubHeader from "../layouts/Employee/SubHeader";

const Payroll = () => {
  const payrollData = [
    {
      description: "Payroll for 02/01/2025 – 02/16/2025",
      startDate: "2025-02-01",
      endDate: "2025-02-16",
      basic: 5000,
      deminimis: 1000,
      ot: 500,
      absLate: -200,
      sss: 500,
      philhealth: 300,
      pagibig: 200,
      tax: 800,
      net: 4700,
    },
    {
      description: "Payroll for 01/16/2025 – 01/31/2025",
      startDate: "2025-01-16",
      endDate: "2025-01-31",
      basic: 5000,
      deminimis: 1000,
      ot: 0,
      absLate: -100,
      sss: 500,
      philhealth: 300,
      pagibig: 200,
      tax: 700,
      net: 5200,
    },
    {
      description: "Payroll for 01/01/2025 – 01/15/2025",
      startDate: "2025-01-01",
      endDate: "2025-01-15",
      basic: 4800,
      deminimis: 900,
      ot: 200,
      absLate: -150,
      sss: 500,
      philhealth: 300,
      pagibig: 200,
      tax: 750,
      net: 4550,
    },
    ...Array.from({ length: 100 }).map((_, i) => ({
      description: `Payroll Sample ${i + 1}`,
      startDate: "2025-01-01",
      endDate: "2025-01-15",
      basic: 5000,
      deminimis: 1000,
      ot: 0,
      absLate: 0,
      sss: 500,
      philhealth: 300,
      pagibig: 200,
      tax: 700,
      net: 5300,
    })),
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [showModal, setShowModal] = useState(false);

  // Filter data by date range
  const filteredData = payrollData.filter((row) => {
    if (!fromDate && !toDate) return true;
    const rowStart = new Date(row.startDate);
    const rowEnd = new Date(row.endDate);

    const from = fromDate ? new Date(fromDate) : null;
    const to = toDate ? new Date(toDate) : null;

    if (from && rowEnd < from) return false;
    if (to && rowStart > to) return false;

    return true;
  });

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentRows = filteredData.slice(startIndex, startIndex + rowsPerPage);

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const getPageNumbers = (isMobile) => {
    let pages = [];
    if (isMobile) {
      let start = Math.max(1, currentPage - 2);
      let end = Math.min(totalPages, start + 4);
      if (end - start < 4) {
        start = Math.max(1, end - 4);
      }
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    } else {
      let maxVisible = 2;
      pages.push(1);
      if (currentPage - maxVisible > 2) pages.push("...");
      for (
        let i = Math.max(2, currentPage - maxVisible);
        i <= Math.min(totalPages - 1, currentPage + maxVisible);
        i++
      ) {
        pages.push(i);
      }
      if (currentPage + maxVisible < totalPages - 1) pages.push("...");
      if (totalPages > 1) pages.push(totalPages);
      return pages;
    }
  };

  const isMobile = window.innerWidth <= 768;

  return (
    <div>
      <Header />
      <SubHeader />
    <div className="payroll-container">
      <div className="payroll-header">
        <h2>Payroll History</h2>
        <div className="filter-actions">
          <button className="btn-modern" onClick={() => setShowModal(true)}>
            Filter by Date
          </button>
          <button
            className="btn-outline"
            onClick={() => {
              setFromDate("");
              setToDate("");
              setCurrentPage(1);
            }}
          >
            Clear Filter
          </button>
        </div>
      </div>

      {/* Modal for Date Filter */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Filter by Date</h3>
            <label>
              From:
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </label>
            <label>
              To:
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </label>
            <div className="modal-actions">
              <button onClick={() => setShowModal(false)}>Apply</button>
              <button className="secondary" onClick={() => setShowModal(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <table className="payroll-table">
        <thead>
          <tr>
            <th>Description</th>
            <th>Basic</th>
            <th>DeMinimis</th>
            <th>OT</th>
            <th>Abs & Late</th>
            <th>SSS</th>
            <th>PhilHealth</th>
            <th>PAGIBIG</th>
            <th>Tax</th>
            <th>Net Amount</th>
          </tr>
        </thead>
        <tbody>
          {currentRows.map((row, index) => (
            <tr key={index}>
              <td>{row.description}</td>
              <td data-label="Basic">₱{row.basic.toFixed(2)}</td>
              <td data-label="DeMinimis">₱{row.deminimis.toFixed(2)}</td>
              <td data-label="OT">₱{row.ot.toFixed(2)}</td>
              <td data-label="Abs & Late">₱{row.absLate.toFixed(2)}</td>
              <td data-label="SSS">₱{row.sss.toFixed(2)}</td>
              <td data-label="PhilHealth">₱{row.philhealth.toFixed(2)}</td>
              <td data-label="PAGIBIG">₱{row.pagibig.toFixed(2)}</td>
              <td data-label="Tax">₱{row.tax.toFixed(2)}</td>
              <td data-label="Net Amount" className="net-amount">
                ₱{row.net.toFixed(2)}
              </td>
            </tr>
          ))}
          {currentRows.length === 0 && (
            <tr>
              <td colSpan="10" style={{ textAlign: "center" }}>
                No payroll records found.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="pagination">
        <button onClick={() => goToPage(1)} disabled={currentPage === 1}>
          First
        </button>
        <button
          onClick={() => goToPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>

        {getPageNumbers(isMobile).map((p, index) =>
          p === "..." ? (
            <span key={index} className="ellipsis">
              ...
            </span>
          ) : (
            <button
              key={index}
              className={currentPage === p ? "active" : ""}
              onClick={() => goToPage(p)}
            >
              {p}
            </button>
          )
        )}

        <button
          onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
        <button
          onClick={() => goToPage(totalPages)}
          disabled={currentPage === totalPages}
        >
          Last
        </button>
      </div>
    </div>
    </div>
  );
};

export default Payroll;
